import * as React from 'react'
import { Box } from '@mui/material'
type Props = { width?: string; height?: string }
const CheckCircle = (props: Props) => {
  return (
    <Box display={'flex'} width={props.width || '15px'} height={props.height || '15px'}>
      <svg xmlns="http://www.w3.org/2000/svg" width={props.width || '15'} height="15" viewBox="0 0 15 15" fill="none">
        <g clipPath="url(#clip0_7_425)">
          <path
            d="M13.75 6.92491V7.49991C13.7492 8.84768 13.3128 10.1591 12.5058 11.2386C11.6989 12.318 10.5646 13.1077 9.2721 13.4899C7.97964 13.872 6.59829 13.8261 5.33404 13.359C4.0698 12.892 2.99041 12.0287 2.25685 10.8981C1.52329 9.76744 1.17487 8.42995 1.26355 7.08511C1.35223 5.74027 1.87325 4.46012 2.74892 3.43559C3.6246 2.41105 4.80799 1.69703 6.12262 1.40001C7.43725 1.10298 8.81267 1.23888 10.0438 1.78742"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.75 2.5L7.5 8.75625L5.625 6.88125"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_7_425">
            <rect width="15" height="15" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Box>
  )
}
export default CheckCircle
